import React from 'react';
import './DesignerLMSMain.css';

const DesignerLMSMain = () => {
  console.log('[DesignerLMSMain] Render');
  return (
    <div className="academy-page-shell designer-lms-main">
      <div className="lms-main-welcome">
        <h1>Welcome, Designer!</h1>
        <p className="lms-main-desc">Create and manage course content and resources. Use the sidebar to access your design tools.</p>
        <div className="lms-main-graphic designer"></div>
      </div>
    </div>
  );
};

export default DesignerLMSMain;
